import useHttp from "./useHttp";
import { useSelector } from "react-redux";

const SEEN_TICKETS_KEY = "seen_ticket_popups";

const getSeenTicketIds = () => {
  try {
    const raw = localStorage.getItem(SEEN_TICKETS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

const markTicketsAsSeen = (ids) => {
  try {
    const existing = getSeenTicketIds();
    const merged = Array.from(new Set([...existing, ...ids]));
    localStorage.setItem(SEEN_TICKETS_KEY, JSON.stringify(merged));
  } catch (e) {}
};

export default function useTicket() {
  // const dispatch = useDispatch();
  const { TicketHttpService } = useHttp();

  const unreadMessages = useSelector(
    (state) => state.TechAppReducer.unreadMessages
  );

  const getUnreadTickets = async (page = 1, per_page = 10) => {
    try {
      const response = await TicketHttpService.get(`/api/v1/tickets?page=${page}&per_page=${per_page}`);
      const seenIds = getSeenTicketIds();
      const newlySeenIds = [];
      response.data.data.forEach((item) => {
        if (item.readed === false && !seenIds.includes(item.id)) {
          unreadMessages.push(item);
          newlySeenIds.push(item.id);
        }
      });
    } catch ({ err, response }) {}
  };

  const getUnreadAnnouncements = async (type, page = 1, per_page = 10) => {
    try {
      const response = await TicketHttpService.get(
        `/api/v1/announcements?page=${page}&per_page=${per_page}&type=${type}`
      );
      response.data.data.forEach((item) => {
        if (item.readed === false) {
          unreadMessages.push(item);
        }
      });
    } catch ({ err, response }) {}
  };

  const exports = { getUnreadTickets, getUnreadAnnouncements, getSeenTicketIds, markTicketsAsSeen };

  return exports;
}
